var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DataCache } from '../../DataCache';
import { TvSymbolConvertor } from '../Convertors/TvSymbolConvertor';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { ReportType } from '../../cache/AllowedReport';
import { TvAccountHelper } from '../Helpers/TvAccountHelper';
import { tvch } from '../Helpers/TvConsoleHelper';
import { ReportManager } from '@shared/utils/Managers/ReportManager';
export class TvExecutionsManager {
    constructor(host) {
        this.host = host;
        this.subscribe();
    }
    executions(symbol) {
        return __awaiter(this, void 0, void 0, function* () {
            const account = TvAccountHelper.getCurrentAccount();
            const startTime = new Date(0).getTime();
            const finishTime = new Date().setHours(23, 59, 59);
            const login = account === null || account === void 0 ? void 0 : account.FullAccString;
            ReportManager.reportsByComplited.set(ReportType.REPORT_TRADES, false);
            const rTrades = yield ReportManager.sendRequestByDate(ReportType.REPORT_TRADES, startTime, finishTime, login);
            const executions = [];
            for (const rTrade of rTrades) {
                if (rTrade.Account !== account)
                    continue;
                if (isNullOrUndefined(rTrade.Instrument))
                    continue;
                const execution = this.convertTradeToExecution(rTrade);
                executions.push(execution);
            }
            const filtered = executions.filter((execution) => execution.symbol === symbol);
            if (tvch.isExececutionLoggingEnabled()) {
                console.warn(`History exectuions for ${account === null || account === void 0 ? void 0 : account.FullAccString}:`, filtered);
            }
            return filtered;
        });
    }
    subscribe() {
        DataCache.OnAddNewTradeEvent.Subscribe(this.onAddTradeEvent, this);
    }
    unsubscribe() {
        DataCache.OnAddNewTradeEvent.Subscribe(this.onAddTradeEvent, this);
    }
    onAddTradeEvent(dc /* ? */, trade) {
        var _a;
        if (trade.Account !== TvAccountHelper.getCurrentAccount())
            return;
        if (!trade.Instrument)
            return;
        const execution = this.convertTradeToExecution(trade);
        this.host.executionUpdate(execution);
        if (tvch.isExececutionLoggingEnabled()) {
            console.warn(`Realtime exectuion for ${(_a = trade.Account) === null || _a === void 0 ? void 0 : _a.FullAccString}:`, execution);
        }
    }
    convertTradeToExecution(trade) {
        const execution = {
            id: trade.TradeId,
            symbol: TvSymbolConvertor.getFullname(trade.Instrument),
            price: trade.Price,
            qty: trade.Amount,
            side: trade.BuySell === OperationType.Buy ? 1 /* Side.Buy */ : -1 /* Side.Sell */,
            time: trade.Time.getTime(),
            commission: trade.Comission
            // netAmount
        };
        return execution;
    }
    // #region IDestroyable
    destroy() {
        this.unsubscribe();
    }
}
